<template>
  <div class="ajuda">
    <div class="container">
      <h1 class="display-1 primary--text my-3">Ajuda</h1>
      <v-divider></v-divider>
      <!--p class="subtitle-2 grey--text my-3">
        Neste manual encontram-se instruções para o acesso a NFSe Avulsa para
        utilização. Para visualização dos manuais, se faz necessário que esteja
        instalado em seu computador o Adobe Reader. caso não possua instalado,
        <a href="https://get.adobe.com/br/reader/" target="_blank"
          >clique aqui</a
        >
        e siga as instruções de instalação.
      </p>
      <v-btn
        class="my-2"
        small
        color="primary"
        @click="mostraPDF"
        outlined
      >
        <v-icon small left>exit_to_app</v-icon>
        <span>Baixar Manual</span>
      </v-btn>
      <v-divider></v-divider-->
      <v-layout class="my-4">
        <v-row wrap justify="center">
          <v-flex xs12>
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title>Perguntas e Respostas</v-toolbar-title>
            </v-toolbar>
            <!-- <v-skeleton-loader
              v-if="loading"
              :transition="transition"
              type="table-row-divider"
            ></v-skeleton-loader>-->
            <FaqTabs :perguntas="perguntas" />
          </v-flex>
        </v-row>
      </v-layout>
    </div>
  </div>
</template>

<script>
import FaqTabs from "@/components/FaqTabs.vue";
import EventService from "../services/EventService";

export default {
  props: {
    perguntas: {
      type: Array,
    },
  },
  components: {
    FaqTabs,
  },
  data() {
    return {
      loading: true,
      transition: "fade-transition",
      manuais: null,
      decodeStr: "",
    };
  },
  methods: {
    mostraPDF() {
      let pdf = this.decodeStr;
      // alert(this.decodeStr);

      // let dataURI = "data:application/pdf;base64," + pdf;
      let link = document.createElement("a");
      // link.download = "NFSeAvulsaManual.pdf";
      link.href = this.decodeStr;
      link.textContent = "Baixar PDF";
      link.target = "_blank";
      link.click();
      document.body.appendChild(link);
    },
  },
  created() {
    EventService.getConteudo().then(
        // (response) => {
      // this.loading = false;
      // this.manuais = response.data.listaManual;
      // this.decodeStr = this.manuais[0].url;
    // }
    );
  },
};
</script>
